export async function jobberAuthorize(code: string | null) {
    const params = new URLSearchParams();
    if (code) params.set("code", code);

    const response = await fetch(`/auth/jobber/callback?${params}`, {
        credentials: "include",
    });

    if (!response.ok) {
        throw new Error(`Authorization failed: ${response.status}`);
    }

    return response.json();
}

function sessionHeaders(): Record<string, string> {
    const state = sessionStorage.getItem("state");
    const headers: Record<string, string> = {
        "Content-Type": "application/json",
    };
    if (state) headers["X-INTEGRATION-STATE"] = state;
    return headers;
}

export async function sendVerificationCode(
    phoneNumber: string,
): Promise<{ success: boolean }> {
    const response = await fetch("/auth/send_verification_code", {
        method: "POST",
        credentials: "include",
        headers: sessionHeaders(),
        body: JSON.stringify({ phone_number: phoneNumber }),
    });

    if (!response.ok) {
        throw new Error(`Verification failed: ${response.status}`);
    }

    return response.json();
}

export async function verifyCode(
    phoneNumber: string,
    code: string,
): Promise<{ success: boolean; status: string; variant?: string }> {
    const response = await fetch("/auth/check_verification_code", {
        method: "POST",
        credentials: "include",
        headers: sessionHeaders(),
        body: JSON.stringify({ phone_number: phoneNumber, code }),
    });

    if (!response.ok) {
        throw new Error(`Verification check failed: ${response.status}`);
    }

    return response.json();
}
